import React, { useEffect } from 'react'
import { UpOutlined, DownOutlined } from "@ant-design/icons";

const TopMeteorologicalPicker = ({ selectedDate, predictionDayProps, updatePredictionDay }) => {

    const { predictionDay, setPredictionDay } = predictionDayProps;
    const predictionDate = selectedDate.clone().add(predictionDay, "day").format("DD/MM/YYYY");

    useEffect(() => {
        return () => setPredictionDay(0);
    }, []);

    const handleClick = (value) => {
        const newPredictionDay = predictionDay + value;
        if(newPredictionDay < 0 || newPredictionDay > 9) return;
        else updatePredictionDay(newPredictionDay);
    }

    return (
        <div id='prediction-date-picker'>

            <p>
                Prediction for day 
                <span id="prediction-input">
                    <input type="Number" disabled={true} value={ predictionDay } size="1" pattern="[0-9]"/>
                    <span id="prediction-input-buttons">
                        <button onClick={() => handleClick(1)}><UpOutlined/></button>
                        <button onClick={() => handleClick(-1)}><DownOutlined/></button>
                    </span>
                </span>
                &#40;0-9&#41;. Showing: { predictionDate }.
            </p>
            
        </div>
    );
}

export default TopMeteorologicalPicker;